import * as Sentry from '@sentry/nextjs'

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

  // Use tunnel to bypass ad blockers
  tunnel: '/api/sentry-tunnel',

  // Enable structured logging (if available in this version)
  // enableLogs: true,  // May not be available in v10.25

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  replaysOnErrorSampleRate: 1.0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  integrations: [
    // Session Replay for debugging
    Sentry.replayIntegration({
      // Additional Replay configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true,
    }),
    // Note: consoleIntegration may not be available in Sentry v10.25
    // Console logging will be captured through standard captureException/captureMessage
  ],

  // Environment
  environment: process.env.NODE_ENV,

  // Only send errors in production
  enabled: process.env.NODE_ENV === 'production',

  // Ignore certain errors
  ignoreErrors: [
    // Browser extensions
    'top.GLOBALS',
    'chrome-extension://',
    'moz-extension://',
    // Network errors
    'NetworkError',
    'Network request failed',
    // Firebase Auth errors (expected)
    'auth/popup-closed-by-user',
    'auth/cancelled-popup-request',
    // User not found (expected during race conditions)
    'User not found',
    'Failed to get user',
  ],

  beforeSend(event, hint) {
    // Filter out sensitive data
    if (event.request) {
      // Remove query parameters that might contain sensitive data
      if (event.request.url) {
        try {
          const url = new URL(event.request.url)
          // Remove sensitive query params
          url.searchParams.delete('token')
          url.searchParams.delete('code')
          url.searchParams.delete('password')
          event.request.url = url.toString()
        } catch (e) {
          // Invalid URL, ignore
        }
      }

      // Remove sensitive headers
      if (event.request.headers) {
        const { Authorization, Cookie, ...safeHeaders } = event.request.headers
        event.request.headers = safeHeaders
      }
    }

    return event
  },
})
